// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__AHaSr","links":"Navbar_links__CwCbO","logos":"Navbar_logos__ULbhV","settings-button":"Navbar_settings-button__43lQb"};